import { useTheme } from "@mui/material";
import { useMemo } from "react";
import { createEditorCSSRules } from "../createEditorCSSRules.js";
import { getDefaultEditorTheme } from "../getDefaultEditorTheme.js";
function useEditorCSSRules(editorThemeStyles) {
  const theme = useTheme();
  return useMemo(
    () => createEditorCSSRules(editorThemeStyles ?? {}, getDefaultEditorTheme(theme)),
    [editorThemeStyles, theme]
  );
}
export {
  useEditorCSSRules
};
//# sourceMappingURL=useEditorCSSRules.js.map
